import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnInit,
} from '@angular/core';
import { PgppButtonIconComponent } from '../../shared/components/button/button';
import { ButtonTypeEnum } from '../../core/enums/button-type.enum';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.services';

@Component({
  selector: 'app-login.component',
  imports: [PgppButtonIconComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LoginComponent implements OnInit {
  router: Router = inject(Router);
  authService: AuthService = inject(AuthService);

  protected readonly ButtonType = ButtonTypeEnum;

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
    }
  }

  /**
   * Inicia o fluxo de login via Keycloak.
   * O Keycloak exibe a tela de login e faz brokering para Gov.br se configurado.
   */
  login(): void {
    this.authService.loginRedirect();
  }

  abrirBuscaMedicoIntercambista(): void {
    this.router.navigate(['/busca-medico-intercambista']);
  }

  abrirValidacaoDeclaracao(): void {
    this.router.navigate(['/validacao-declaracao']);
  }
}
